import { uniq } from 'lodash';

// Mirrors the allowed values enforced by core's Cases::SearchValidator. Sending anything else
// results in a 400 Bad Request.
export const PERSON_CASE_STATES = ['managed', 'off_platform'];
export const PERSON_CASE_INTERNAL_STATES = ['managed', 'pending_authorization'];
export const PROVIDER_CASE_STATES = ['draft', 'managed', 'off_platform', 'pending_authorization'];
export const NETWORK_CASE_STATES = ['managed', 'off_platform'];

export const DEFAULT_PERSON_CASE_STATE = PERSON_CASE_STATES.join(',');
export const DEFAULT_PERSON_CASE_INTERNAL_STATE = PERSON_CASE_INTERNAL_STATES.join(',');

/**
 * Keeps only the allowed values of a comma separated string (or array) of states.
 * Returns a comma separated string, or null when no valid value remains.
 */
export const sanitizeCaseStates = (value, allowedStates) => {
  const values = Array.isArray(value) ? value : String(value ?? '').split(',');
  const valid = uniq(
    values
      .map((state) => (typeof state === 'string' ? state.trim() : ''))
      .filter((state) => allowedStates.includes(state)),
  );

  return valid.length ? valid.join(',') : null;
};
